// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StatementBox_wrapper__f-LKY"};